import { render, staticRenderFns } from "./IntergisCfsImageDetailPop.vue?vue&type=template&id=22c5ebdd"
import script from "./IntergisCfsImageDetailPop.vue?vue&type=script&lang=js"
export * from "./IntergisCfsImageDetailPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c5ebdd')) {
      api.createRecord('22c5ebdd', component.options)
    } else {
      api.reload('22c5ebdd', component.options)
    }
    module.hot.accept("./IntergisCfsImageDetailPop.vue?vue&type=template&id=22c5ebdd", function () {
      api.rerender('22c5ebdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/popup/IntergisCfsImageDetailPop.vue"
export default component.exports